import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { AclUtil, CharUtil } from "../ts/rlAdmin.utils";
import { CustomViewsService } from "../services/custom-views-service";

export class ListService {

    static $inject = ['customViewsService'];

    constructor(private customViewsService: CustomViewsService) { }
    GetColumnsFromMetaData(metaData: Models.ICharacteristicMetaDataCollection, acls: string[]): Models.ICustomUserColumn[] {

        let columns = _(AclUtil.filterCMDsByRights(acls, metaData, Consts.AccessRight.Read))
            .sortBy((cmd) => { return cmd.sequenceNumber })
            .map<Models.ICustomUserColumn>((cmd) => {
                return {
                    charTypeID: metaData.charTypeID,
                    characteristicID: cmd.characteristicID,
                    solrLabel: CharUtil.GetCharSolrLabelByCmd(cmd),
                    sequenceNumber: cmd.sequenceNumber,
                    label: cmd.label,
                    formatter: CharUtil.GetFormatter(cmd.dataTypeID),
                    hasLov: cmd.charValueSetID != undefined
                }
            }).value();

        return columns;
    }

    GetRows(itemRows: Array<Models.IEntitySearchDoc | Models.IUsageAmountDocument | Models.IEntitySearchDoc>,
        customColumns: Models.ICustomUserColumn[], availableColumns: Models.IListTableColumn[], lockedRows: _.Dictionary<boolean>, allowedToDeleteRows: _.Dictionary<boolean>): Models.IListTableRow[] {
        if (itemRows.length == 0) return [];

        var charTypeID = itemRows[0].charTypeID;
        var specialColumns = this.customViewsService.GetSpecialColumns(charTypeID);

        customColumns.forEach((col) => {
            if (col.solrLabel.indexOf('_date') > -1 || col.solrLabel.indexOf('_updated') > -1 || col.solrLabel == 'created') {
                col.formatter = 'dateLocal:"L"';
            }

            var overwriteLabel = !(col.label && col.label.includes("Party"));
            // nearly duplicate of code from column-picker.ts, refactor
            if (col.solrLabel.indexOf('_') > -1 && overwriteLabel) {
                var split = col.solrLabel.split('_');
                col.label = '';
                split.forEach((val) => {
                    col.label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1) + ' ';
                });
            } else if (col.solrLabel == 'userlabel') {
                col.label = 'Contact';
            } else if (col.solrLabel == 'companylabel') {
                col.label = 'Company';
            } else if (col.solrLabel == 'created') {
                col.label = 'Created';
            }

            if (col.solrLabel == 'transaction_id') {
                col.label = 'Deal ID';
            }
        });

        var rows: Models.IListTableRow[] = [];
        itemRows.forEach((row) => {
            var sortedColumns = _.sortBy(customColumns, (col) => { return col.sequenceNumber; });

            var columns: Models.IListTableColumn[] = [];
            for (let i = 0; i < sortedColumns.length; i++) {
                var col = sortedColumns[i];
                if (col.characteristicID) {
                    var characteristic = _.find(availableColumns, (aCol) => {
                        return aCol.characteristicID === col.characteristicID;
                    });

                    if (!characteristic) continue;

                    // actual characteristic
                    if (row.characteristics[characteristic.solrLabel]) {
                        var tempValue = row.characteristics[characteristic.solrLabel];
                        if (_.isArray(tempValue)) {
                            if (col.hasLov) {
                                tempValue = _.sortBy(tempValue);
                            }
                            tempValue = tempValue.join(' | ');
                        }
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel,
                            label: characteristic.label || characteristic.solrLabel,
                            value: tempValue,
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID,
                            multipleIndicator: characteristic.multipleIndicator
                        });
                    }
                    // System/header virtual characteristic
                    else if (row[characteristic.solrLabel]) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel == 'title' ? 'title_sort' : characteristic.solrLabel,
                            label: characteristic.label,
                            value: row[characteristic.solrLabel],
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID,
                            multipleIndicator: characteristic.multipleIndicator
                        });
                    }
                    // Special recordID case
                    else if (characteristic.solrLabel == 'recordid' && row['recordID']) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel,
                            label: characteristic.label,
                            value: row['recordID'].toString(),
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID,
                            multipleIndicator: characteristic.multipleIndicator
                        });
                    }
                    // no value on this document
                    else if (characteristic) {
                        columns.push({
                            characteristicID: characteristic.characteristicID,
                            solrLabel: col.solrLabel,
                            label: characteristic.label,
                            value: undefined,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID,
                            multipleIndicator: characteristic.multipleIndicator
                        });
                    }
                    // missing from this record
                    else {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label,
                            value: undefined,
                            dataTypeID: -1,
                            systemIndicatorID: -1,
                            multipleIndicator: -1
                        });
                    }
                }
                else if (col.solrLabel) {
                    var characteristic = _.find(availableColumns, (aCol) => {
                        return aCol.solrLabel === col.solrLabel;
                    });

                    var specialCol = _.find(specialColumns, (sCol) => {
                        return sCol.solrLabel == col.solrLabel;
                    });
                    var test = this.customViewsService.GetDefaultColumns(charTypeID).columns;
                    var defaultCol = _.find(test, (dCol) => {
                        return dCol.solrLabel == col.solrLabel;
                    });

                    if (specialCol) {
                        col.label = specialCol.label;
                    }
                    else if (defaultCol) {
                        col.label = defaultCol.label;
                    }

                    // actual characteristic
                    if (characteristic) {
                        columns.push({
                            characteristicID: col.characteristicID,
                            solrLabel: characteristic.solrLabel == 'title' ? 'title_sort' : col.solrLabel,
                            label: characteristic.label,
                            value: row[characteristic.solrLabel] || row.characteristics[characteristic.solrLabel],
                            formatter: characteristic.formatter,
                            dataTypeID: characteristic.dataTypeID,
                            systemIndicatorID: characteristic.systemIndicatorID,
                            multipleIndicator: characteristic.multipleIndicator
                        });
                    }
                    // header value
                    else if (row[col.solrLabel]) {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel == 'title' ? 'title_sort' : col.solrLabel,
                            label: col.label,
                            value: row[col.solrLabel],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1,
                            multipleIndicator: -1
                        });
                    }
                    // specially indexed value that is not an actual characteristic
                    else if (row.characteristics[col.solrLabel]) {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: _.isArray(row.characteristics[col.solrLabel]) ? row.characteristics[col.solrLabel].join(' | ') : row.characteristics[col.solrLabel],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1,
                            multipleIndicator: -1
                        });
                    }
                    else if (this.isSpecialColumn(col.solrLabel)) {
                        //hack for showing catalog hierarchy
                        columns.push(this.getSpecialColumn(col));
                    }
                    // header value with underscore - we need to access value without but sort with
                    else if (col.solrLabel.indexOf('_') > -1) {
                        var split = col.solrLabel.split('_');
                        var label = split[0];
                        split.splice(0, 1);

                        split.forEach((val) => {
                            label += val.substr(0, 1).toUpperCase() + val.substr(1, val.length - 1);
                        });

                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: row[label],
                            formatter: col.formatter,
                            dataTypeID: -1,
                            systemIndicatorID: -1,
                            multipleIndicator: -1
                        });
                    }
                    // dummy value
                    else {
                        columns.push({
                            characteristicID: -1,
                            solrLabel: col.solrLabel,
                            label: col.label || col.solrLabel,
                            value: undefined,
                            dataTypeID: -1,
                            systemIndicatorID: -1,
                            multipleIndicator: -1
                        });
                    }
                }
            }

            var activeIndicator: number;
            var lockedIndicator: boolean = false;
            var deleteIndicator: boolean = false;
            if (row.charTypeID == Consts.CharTypeIDs.usage) {
                lockedIndicator = row.lockedIndicator == 1;
                deleteIndicator = row.deleteIndicator == 1;
            }
            else if (row.charTypeID == Consts.CharTypeIDs.right) {
                activeIndicator = row.activeIndicator;
                lockedIndicator = row.lockedIndicator == 1;
                deleteIndicator = row.deleteIndicator == 1;
            }
            else if (row.charTypeID == Consts.CharTypeIDs.amount) {
                if (lockedRows != undefined) {
                    lockedIndicator = lockedRows[row.recordID];
                }
                else {
                    lockedIndicator = row.lockedIndicator == 1;
                }

                if (allowedToDeleteRows != undefined) {
                    deleteIndicator = allowedToDeleteRows[row.recordID];
                }
                else {
                    deleteIndicator = row.deleteIndicator == 1;
                }
            }
            else {
                if (lockedRows != undefined) {
                    lockedIndicator = lockedRows[row.recordID];
                }
                if (allowedToDeleteRows != undefined) {
                    deleteIndicator = allowedToDeleteRows[row.recordID];
                }
            }


            rows.push({
                recordID: row.recordID,
                columns: columns,
                recordRevisionID: row.recordRevisionID,
                title: row.title,
                currency: row.characteristics['currency_str'],
                activeIndicator: activeIndicator,
                lockedIndicator: lockedIndicator,
                deleteIndicator: deleteIndicator,
                entityID: row.entityID,
                templateGroupID: row.templateGroupID,
                templateID: row.templateID,
                statusID: row.statusID
            });
        });

        return rows;
    }

    isSpecialColumn(solrLabel: string): boolean {
        return this.isSpecialPropertyColumn(solrLabel) || this.isSpecialTransactionColumn(solrLabel);
    }
    isSpecialTransactionColumn(solrLabel: string): boolean {
        return solrLabel === "deal_id" ||
            solrLabel === "deal_title" ||
            solrLabel === "deal_primary_contact";
    }
    isSpecialPropertyColumn(solrLabel: string): boolean {
        return solrLabel === "direct_parent" ||
            solrLabel === "top_parent" ||
            solrLabel === "catalog_source";
    }
    getSpecialColumn(col: Models.ICustomUserColumn): Models.IListTableColumn {
        return {
            characteristicID: -1,
            solrLabel: col.solrLabel,
            label: col.label || col.solrLabel,
            value: '',
            formatter: col.formatter,
            dataTypeID: -1,
            systemIndicatorID: -1,
            multipleIndicator: -1
        };
    }
}
